<template>
  <div>
    <h4 class="title">Can’t add a new integration</h4>
    <i
      @click="$bvModal.hide('noGroups')"
      class="mdi mdi-close-circle close-icon"
    ></i>
    <p class="content">
      No groups are available to be mapped for these credentials.
    </p>
  </div>
</template>

<script>
export default {
  mounted() {},
  beforeMount() {
    console.log("No groups Modal");
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #c7c7c7;
}

.close-icon {
  position: absolute;
  top: 21px;
  inset-inline-end: 26px;
  color: #f46a6a;
  font-size: 1.7rem;
  cursor: pointer;
}

.content {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #495057;
}
</style>
